module.exports = __webpack_public_path__ + "img/answer-c2-2.60d7fa1c.png";